import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#030308] py-16 px-4 border-t border-white/5" data-id="element-268">
      <div className="max-w-4xl mx-auto text-center" data-id="element-269">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3 drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" data-id="element-270">
          <span className="text-4xl" data-id="element-271">🏊</span> EDULABS™
        </div>

        <p className="text-white/80 text-lg leading-relaxed mb-3 max-w-xl mx-auto font-medium" data-id="element-272">
          El sistema de enseñanza N°1 para profesionales de la natación.
        </p>
        <p className="text-white/50 text-sm italic mb-10" data-id="element-273">
          Porque enseñar natación no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/70 mb-10" data-id="element-274">
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-275">
            <span data-id="element-276">📧</span> soporte.edulabs@gmail.com
          </span>
          <span className="hidden sm:inline text-white/20" data-id="element-277">•</span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-278">
            <span data-id="element-279">📲</span> @edulabs.oficial
          </span>
          <span className="hidden sm:inline text-white/20" data-id="element-280">•</span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-281">
            <span data-id="element-282">🌐</span> www.edulabs.online
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-283" />

        <p className="text-white/30 text-xs tracking-wider" data-id="element-284">
          © EDULABS™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}